var _polygon, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "135.14px",
    height: "36px",
    viewBox: "0 0 135.14 36",
    enableBackground: "new 0 0 135.14 36",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#042b62",
    points: "36.51,20.719 36.544,20.65 40.994,13.199 27.162,13.199 24.956,10.441 42.614,10.475 47.927,1.542  8.985,1.645 28.645,33.962 33.922,25.03 31.611,20.719 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M55.306,12.407h-4.403v3.063h4.046v2.279h-4.046v4.848h-2.811V10.119h7.214V12.407z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M63.003,22.597h-2.811V10.119h2.811V22.597z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.9,22.597h-2.837l-5.144-7.841c-0.3-0.458-0.51-0.803-0.626-1.035h-0.035 c0.047,0.441,0.069,1.113,0.069,2.019v6.857h-2.653V10.119h3.029l4.951,7.597c0.226,0.342,0.435,0.682,0.627,1.019h0.034 c-0.047-0.291-0.069-0.862-0.069-1.715v-6.9H79.9V22.597z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M94.35,12.407h-3.558v10.19h-2.819v-10.19h-3.542v-2.288h9.919V12.407z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M103.479,22.814c-1.787,0-3.244-0.581-4.369-1.745c-1.126-1.162-1.688-2.678-1.688-4.546 c0-1.972,0.57-3.568,1.714-4.786c1.143-1.218,2.657-1.827,4.543-1.827c1.78,0,3.221,0.583,4.32,1.749 c1.099,1.166,1.648,2.703,1.648,4.612c0,1.96-0.57,3.542-1.71,4.743C106.799,22.213,105.312,22.814,103.479,22.814z  M103.601,12.329c-0.986,0-1.77,0.37-2.351,1.109c-0.579,0.74-0.869,1.719-0.869,2.937c0,1.235,0.29,2.213,0.869,2.933 c0.581,0.719,1.34,1.078,2.28,1.078c0.969,0,1.738-0.349,2.307-1.049c0.567-0.698,0.852-1.669,0.852-2.91 c0-1.294-0.275-2.3-0.825-3.02C105.312,12.688,104.557,12.329,103.601,12.329z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M119.821,22.814c-1.786,0-3.243-0.581-4.368-1.745c-1.126-1.162-1.688-2.678-1.688-4.546 c0-1.972,0.57-3.568,1.713-4.786c1.144-1.218,2.657-1.827,4.544-1.827c1.779,0,3.221,0.583,4.32,1.749 c1.099,1.166,1.648,2.703,1.648,4.612c0,1.96-0.57,3.542-1.71,4.743C123.142,22.213,121.655,22.814,119.821,22.814z  M119.943,12.329c-0.985,0-1.769,0.37-2.35,1.109c-0.579,0.74-0.869,1.719-0.869,2.937c0,1.235,0.29,2.213,0.869,2.933 c0.581,0.719,1.34,1.078,2.28,1.078c0.969,0,1.737-0.349,2.307-1.049c0.567-0.698,0.852-1.669,0.852-2.91 c0-1.294-0.275-2.3-0.825-3.02C121.655,12.688,120.9,12.329,119.943,12.329z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.11d1a1be0e8fc380091ed383a9fdee02.svg";
export { ForwardRef as ReactComponent };